import type { CSSProperties } from 'react';

/**
 * The animated stage line ("fiber"): lit up to `lit` %, with a pulse of light running along the lit part.
 * run: blue, moving glow · won: all lit, green glow · paused: amber, no glow · done: green, no glow ·
 * unknown: dashed grey (not enough data) · scan: blue, the light sweeping the whole line (working, not measured yet) · off: grey. An optional tick marks where the work should be by now.
 */
export function Fiber({ lit, tone = 'run', pace, className = '' }: {
  lit: number; tone?: 'run' | 'won' | 'paused' | 'done' | 'unknown' | 'scan' | 'off'; pace?: number | null; className?: string;
}) {
  const cls = { run: '', won: ' full', paused: ' paused', done: ' done', unknown: ' unknown', scan: ' scan', off: ' off' }[tone];
  return (
    <div className={`fiber${cls}${className ? ` ${className}` : ''}`} aria-hidden="true" style={{ '--lit': `${Math.max(0, Math.min(100, lit))}%` } as CSSProperties}>
      <span />
      {pace != null && <i className="fiber-pace" style={{ left: `${Math.max(0, Math.min(100, pace))}%` }} />}
    </div>
  );
}
